<!-- <app-access-manager [namespace]="namespace"></app-access-manager> -->

<input
  type="radio"
  name="view"
  value="brand"
  [(ngModel)]="selectedView"
  (change)="onViewChange($event)"
/>
Brand Partners
<input
  type="radio"
  name="view"
  value="sales"
  [(ngModel)]="selectedView"
  (change)="onViewChange($event)"
/>
Sales
<input
  type="radio"
  name="view"
  value="manage"
  [(ngModel)]="selectedView"
  (change)="onViewChange($event)"
/>
Manager

<h1>Residuals Dashboard</h1>

<!-- Brand view -->
<div style="margin-bottom: 20px" [hidden]="selectedView != 'brand'">
  <div>
    <h2>Propelled Brands</h2>
  </div>

  <div style="width: 200px">
    <app-ddl-input
      [options]="brands"
      [(ngModel)]="selectedBrandId"
      [label]="'Select a brand'"
    ></app-ddl-input>
  </div>

  <div>
    <div class="filterableTable" [showLoadingSpinner]="false">
      <div class="sectionContainer">
        <table class="selectableTable">
          <tr>
            <th class="sortable">Brand</th>
            <th>Date</th>
            <th></th>
          </tr>

          <tr [ngClass]="{ even: false, odd: true }" class="rowSummary">
            <td style="width: 15%">Fast Signs</td>
            <td style="width: 15%">March 2025</td>
            <td style="width: 15%">
              <app-button-input
                [icon]="'PDF'"
                [class]="'button_right-spacing'"
                [title]="'Download PDF'"
              ></app-button-input>
            </td>
          </tr>
          <tr [ngClass]="{ even: true, odd: false }" class="rowSummary">
            <td style="width: 15%">Fast Signs</td>
            <td style="width: 15%">February 2025</td>
            <td style="width: 15%">
              <app-button-input
                [icon]="'PDF'"
                [class]="'button_right-spacing'"
                [title]="'Download PDF'"
              ></app-button-input>
            </td>
          </tr>
        </table>

        <mat-paginator
          #paginator
          [class]="'paginator'"
          [length]="10"
          [pageIndex]="0"
          [pageSize]="1"
          [pageSizeOptions]="[5, 10, 25, 50]"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- Sales view -->
<div style="margin-bottom: 20px" [hidden]="selectedView != 'sales'">
  <div style="width: 200px">
    <app-ddl-input
      [options]="getAgentListItems()"
      [(ngModel)]="selectedAgentId"
      [label]="'Select an agent'"
    ></app-ddl-input>
  </div>

  <div>
    <div class="filterableTable" [showLoadingSpinner]="false">
      <div class="sectionContainer">
        <table class="selectableTable">
          <tr>
            <th class="sortable">Agent</th>
            <th>Date</th>
            <th></th>
          </tr>

          <tr [ngClass]="{ even: false, odd: true }" class="rowSummary">
            <td style="width: 15%">Michael Dahlheimer</td>
            <td style="width: 15%">March 2025</td>
            <td style="width: 15%">
              <app-button-input
                [icon]="'PDF'"
                [class]="'button_right-spacing'"
                [title]="'Download PDF'"
              ></app-button-input>
            </td>
          </tr>
          <tr [ngClass]="{ even: true, odd: false }" class="rowSummary">
            <td style="width: 15%">Michael Dahlheimer</td>
            <td style="width: 15%">February 2025</td>
            <td style="width: 15%">
              <app-button-input
                [icon]="'PDF'"
                [class]="'button_right-spacing'"
                [title]="'Download PDF'"
              ></app-button-input>
            </td>
          </tr>
        </table>

        <mat-paginator
          #paginator
          [class]="'paginator'"
          [length]="10"
          [pageIndex]="0"
          [pageSize]="1"
          [pageSizeOptions]="[5, 10, 25, 50]"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- Manage Residuals view -->
<div style="margin-bottom: 20px" [hidden]="selectedView != 'manage'">
  <div>
    <h2>Manage Residuals</h2>

    <app-ddl-input
      [options]="getPartnerListItems()"
      [(ngModel)]="selectedPartnerId"
      (ngModelChange)="onPartnerChange($event)"
      [label]="'Select a partner'"
    ></app-ddl-input>

    <div [hidden]="selectedPartner == undefined">
      <div>
        <h3>{{ selectedPartner?.name }}</h3>
      </div>

      <app-ddl-input
        [options]="brands"
        [(ngModel)]="selectedBrandId"
        [label]="'Select a brand'"
      ></app-ddl-input>

      <div [hidden]="selectedBrandId == undefined">
        <div style="margin-bottom: 20px">
          <app-button-input
            [icon]="'PlusAdd'"
            [text]="'Add Residual Report'"
            [class]="'button_right-spacing'"
            [title]="'Add Residual Report'"
            (click)="openAddResidualReportDialog()"
          ></app-button-input>
        </div>

        <div class="filterableTable" [showLoadingSpinner]="false">
          <div class="sectionContainer">
            <table class="selectableTable">
              <tr>
                <th class="sortable">Brand</th>
                <th>Date</th>
                <th></th>
              </tr>

              <tr [ngClass]="{ even: false, odd: true }" class="rowSummary">
                <td style="width: 15%">Fast Signs</td>
                <td style="width: 15%">March 2025</td>
                <td style="width: 15%">
                  <app-button-input
                    [icon]="'PDF'"
                    [class]="'button_right-spacing'"
                    [title]="'Download PDF'"
                  ></app-button-input>
                  <app-button-input
                    [icon]="'MinusRemove'"
                    [color]="'#ffffff'"
                    [title]="'Delete'"
                  ></app-button-input>
                </td>
              </tr>
              <tr [ngClass]="{ even: true, odd: false }" class="rowSummary">
                <td style="width: 15%">Fast Signs</td>
                <td style="width: 15%">February 2025</td>
                <td style="width: 15%">
                  <app-button-input
                    [icon]="'PDF'"
                    [class]="'button_right-spacing'"
                    [title]="'Download PDF'"
                  ></app-button-input>
                  <app-button-input
                    [icon]="'MinusRemove'"
                    [color]="'#ffffff'"
                    [title]="'Delete'"
                  ></app-button-input>
                </td>
              </tr>
            </table>

            <mat-paginator
              #paginator
              [class]="'paginator'"
              [length]="10"
              [pageIndex]="0"
              [pageSize]="1"
              [pageSizeOptions]="[5, 10, 25, 50]"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>

    <!-- <app-ddl-input [options]="brands" [(ngModel)]="selectedBrand" [label]="'Select a brand'"></app-ddl-input> -->
  </div>
</div>
